var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCanUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.5625C5.25 6.32088 5.05412 6.125 4.8125 6.125C4.57088 6.125 4.375 6.32088 4.375 6.5625V10.0625C4.375 10.3041 4.57088 10.5 4.8125 10.5C5.05412 10.5 5.25 10.3041 5.25 10.0625V6.5625Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 6.125C6.80412 6.125 7 6.32088 7 6.5625V10.0625C7 10.3041 6.80412 10.5 6.5625 10.5C6.32088 10.5 6.125 10.3041 6.125 10.0625V6.5625C6.125 6.32088 6.32088 6.125 6.5625 6.125Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.5625C8.75 6.32088 8.55412 6.125 8.3125 6.125C8.07088 6.125 7.875 6.32088 7.875 6.5625V10.0625C7.875 10.3041 8.07088 10.5 8.3125 10.5C8.55412 10.5 8.75 10.3041 8.75 10.0625V6.5625Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2.40625V3.5H0.875C0.633376 3.5 0.4375 3.69588 0.4375 3.9375C0.4375 4.17912 0.633376 4.375 0.875 4.375H1.79157L2.50898 11.5491C2.59844 12.4437 3.35123 13.125 4.2503 13.125H8.87469C9.77375 13.125 10.5266 12.4437 10.616 11.5491L11.3334 4.375H12.25C12.4916 4.375 12.6875 4.17912 12.6875 3.9375C12.6875 3.69588 12.4916 3.5 12.25 3.5H9.625V2.40625C9.625 1.56056 8.93944 0.875 8.09375 0.875H5.03125C4.18556 0.875 3.5 1.56056 3.5 2.40625ZM5.03125 1.75C4.66882 1.75 4.375 2.04382 4.375 2.40625V3.5H8.75V2.40625C8.75 2.04382 8.45618 1.75 8.09375 1.75H5.03125ZM10.4541 4.375L9.7454 11.4621C9.7006 11.9094 9.32426 12.25 8.87469 12.25H4.2503C3.80076 12.25 3.42437 11.9094 3.37964 11.4621L2.67093 4.375H10.4541Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanUser);
export default __webpack_public_path__ + "static/media/trashCanUser.07172eb9319b68c676cd4419a72092a1.svg";
export { ForwardRef as ReactComponent };